<template>
  <div id="CourseAdd" v-loading="loading" class="">
    <el-tabs v-model="activeName" @tab-click="handleClick" :before-leave="beforeLeave">
      <el-tab-pane label="基本信息" name="first">
        <Course-baseInformation ref="CourseBaseInformation"></Course-baseInformation>
      </el-tab-pane>
      <el-tab-pane label="推送设置" name="second">
        <Course-pushSetting ref="CoursePushSetting"></Course-pushSetting>
      </el-tab-pane>
      <el-tab-pane label="宣传资料" name="third">
        <Course-collateral ref="CourseCollateral"></Course-collateral>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
import { confirmMsg } from '@/utils/common'
import CourseBaseInformation from './Course-baseInformation'
import CoursePushSetting from './Course-pushSetting'
import CourseCollateral from './Course-collateral'
export default {
  name: 'CourseAdd',
  components: {
    CourseBaseInformation,
    CoursePushSetting,
    CourseCollateral,
  },
  data () {
     return {
      loading: false,
       activeName: 'first'

    }
  },
  methods: {
    // 获取数据
    getList () {
      // this.loading = true
    },


    updateType () {
      let tabs = this.$route.query.tabs
      // 判断type的值，更改activeName的值
      console.log(tabs);
      if (tabs === 'first' || tabs == undefined) {
        this.activeName = 'first'
      } else if (tabs === 'second') {
        this.activeName = 'second'
      }else if (tabs === 'third') {
        this.activeName = 'third'
      }
    },



    beforeLeave(){
      // return false
    },

    handleClick(tab, event) {
      console.log(tab, event);
    },


  },
  mounted: function () {
    this.updateType()
  },
  created () {
    this.getList()
  },
  computed: {
    getUId () {
      return localStorage.getItem('uid') 
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-tabs__item{
  font-size: 12px;
}
/deep/.el-tabs__item{
  padding: 0 10px !important;
}
/deep/.el-pagination.is-background .btn-next, /deep/.el-pagination.is-background .btn-prev, /deep/.el-pagination.is-background .el-pager li{
  background-color: #E2E8F4;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active{
  background-color: #265480;
}
</style>
